import React, {useEffect, useState} from 'react'
import Ajax from '../../../../../helpers/Ajax'
import TableLoader from '../../../../UI/Dashboard/TableLoader';
import DataView from '../../../../UI/Dashboard/DataView';
import TableContainer from '../../../../UI/Dashboard/TableContainer';
import { Helmet } from 'react-helmet-async';
import ContentLayout from '../../../../Common/ContentLayout';
import EditButton from '../../../../UI/Dashboard/EditButton';
import DeleteButton from '../../../../UI/Dashboard/DeleteButton';

export default function ProcessList() {
    const [process, setProcess] = useState(null)
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/home/step`,
            token: true,
        })
        if(response.data.status === "SUCCESS!"){
            setProcess(response.data.result)
        }
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[])

    return (
    <ContentLayout title='Process' addNew='/admin/home/process/add-new'>
        <div className="row">
        <Helmet>
            <title>Process</title>
        </Helmet>
        <DataView title="Process List">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">Title</td>
                        <td className="text-start">Description</td>
                        <td className="text-start">Order</td>
                        <td className="text-start">Type</td>
                        <td className="text-center">Edit</td>
                        <td className="text-center">Delete</td>
                    </tr>
                </thead>
                <tbody>
                    {process == null ? 
                    <TableLoader cols={7}/> : process.length === 0 ? 
                    <tr>
                        <td colSpan={7} className="text-center">Data not available</td>
                    </tr> : process.map((data, index)=>(
                    <tr key={data._id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start text-capitalize">{data.name}</td>
                        <td className="text-start">{data.description}</td>
                        <td className="text-start">{data.sortOrder}</td>
                        <td className="text-start">{data.type}</td>
                        <td className="text-center">
                            <EditButton>{`/admin/home/process/${data._id}`}</EditButton>
                        </td>
                        <td className="text-center">
                            <DeleteButton url="/home/step" id={data._id} />
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
